export default __webpack_public_path__ + "static/media/ISSO CLASS-8 EXAM PATTERN 2025.ac06174a.pdf";